import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import eventEmitter from '@growth/dom-event-emitter';
import { g as getDsdUserSearchIntent, a as getUserLastHotelFlightLocation } from './helper-b92d0092.esm.js';

var EVENT_RELOAD_SKYWALKER = 'rl_sky';

var reloadSkywalkerEvent = function reloadSkywalkerEvent() {
  eventEmitter.emit(EVENT_RELOAD_SKYWALKER);
};
var isValidServerSkywalkerResponse = function isValidServerSkywalkerResponse(res) {
  var _res$sequenceData, _res$data;
  var v = false;
  if (!res) return v;
  var seqD = (res == null || (_res$sequenceData = res.sequenceData) == null || (_res$sequenceData = _res$sequenceData.BASE_SHEET) == null || (_res$sequenceData = _res$sequenceData.cardSequence) == null ? void 0 : _res$sequenceData.data) || [];
  var cardD = (res == null || (_res$data = res.data) == null || (_res$data = _res$data.BASE_SHEET) == null ? void 0 : _res$data.cardData) || {};
  seqD.forEach(function (card) {
    if (!cardD[card == null ? void 0 : card.id]) {
      v = false;
      return;
    }
    v = true;
  });
  return v;
};
var getExtraReqBody = function getExtraReqBody() {
  // if hotel/flight has any recent search , will send the recent search
  // while making a skywalker api call to get the user last city selected location deals
  var dsdUserSearchHistory = getDsdUserSearchIntent();
  var userSelectedDSDLocations = getUserLastHotelFlightLocation();
  return _extends({}, dsdUserSearchHistory, userSelectedDSDLocations);
};

// pdt analytics is large in size, not using pdt for lobs renderer by default
var pdtPushInstance = {
  track: function track(event, o) {}
};
var adobePushInstance = {
  track: function track(event, o) {
    if (window.adobeDataLayer) {
      window.adobeDataLayer.push(_extends({
        event: event
      }, o));
    }
  }
};

export { EVENT_RELOAD_SKYWALKER as E, adobePushInstance as a, getExtraReqBody as g, isValidServerSkywalkerResponse as i, pdtPushInstance as p, reloadSkywalkerEvent as r };
